export default "__VITE_PUBLIC_ASSET__80b47228__"